<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="610px"
    :title="$l('INDEX.dialog_title_batch_update') || '批量更新箱规尺寸'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_goodsProperties') || '产品属性'"
            prop="goodsProperties"
          >
            <dict-select
              v-model="formData.goodsProperties"
              url="/master/common/dict/biz"
              :body="{ dictType: 'goodsProperties' }"
              :selectedLabel.sync="formData.goodsProperties"
              clearable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_unitLength') || '单品包装长(cm)'"
                prop="unitLength"
              >
                <el-input-number
                  v-model="formData.unitLength"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_unitWidth') || '单品包装宽(cm)'"
                prop="unitWidth"
              >
                <el-input-number
                  v-model="formData.unitWidth"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_unitHeight') || '单品包装高(cm)'"
                prop="unitHeight"
              >
                <el-input-number
                  v-model="formData.unitHeight"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6" :offset="6">
          <el-form-item
            :label="$l('INDEX.form_label_goodsWeight') || '单品重量(kg)'"
            prop="goodsWeight"
          >
            <el-input-number
              v-model="formData.goodsWeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_unitWeight') || '单品包装重量(kg)'"
            prop="unitWeight"
          >
            <el-input-number
              v-model="formData.unitWeight"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              @change="changeCtnGrossWeight"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_unitCbm') || '单品包装体积(m³)'"
            prop="unitCbm"
          >
            <el-input v-model="unitCbm" controls-position="right" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_inCtnQty') || '装箱入数'"
            prop="inCtnQty"
          >
            <el-input-number
              v-model="formData.inCtnQty"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="0"
              style="width:100%"
              @change="changeCtnGrossWeight"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnLength') || '纸箱长(cm)'"
                prop="ctnLength"
              >
                <el-input-number
                  v-model="formData.ctnLength"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnWidth') || '纸箱宽(cm)'"
                prop="ctnWidth"
              >
                <el-input-number
                  v-model="formData.ctnWidth"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_label_ctnHeight') || '纸箱高(cm)'"
                prop="ctnHeight"
              >
                <el-input-number
                  v-model="formData.ctnHeight"
                  controls-position="right"
                  :step="1"
                  :min="0"
                  :precision="2"
                  style="width:100%"
                  v-el-inputnumber-default0
                >
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6" :offset="6">
          <el-form-item
            :label="$l('INDEX.form_label_ctnNetWeight') || '箱净重(kg)'"
          >
            <el-input-number
              v-model="ctnNetWeightKgRead"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_ctnGrossWeight') || '箱毛重(kg)'"
          >
            <el-input-number
              v-model="ctnGrossWeightKgRead"
              controls-position="right"
              :step="1"
              :min="0"
              :precision="3"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_ctnCbm') || '纸箱体积(m³)'"
          >
            <el-input v-model="ctnCbm" controls-position="right" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">{{
        $l('INDEX.btn_cancel') || '取 消'
      }}</el-button>
      <el-button size="small" type="primary" @click="save">{{
        $l('INDEX.btn_update') || '更新'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import {
  multiply,
  multiplyRound,
  divideRound,
  add,
} from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {},
      ctnGrossWeightKgRead: 0,
      ctnNetWeightKgRead: 0,
    }
  },
  computed: {
    unitCbm() {
      const { unitLength, unitWidth, unitHeight } = this.formData
      return divideRound(
        multiply(multiply(unitLength, unitWidth), unitHeight),
        1000000,
        8
      )
    },
    ctnCbm() {
      const { ctnLength, ctnWidth, ctnHeight } = this.formData
      return divideRound(
        multiply(multiply(ctnLength, ctnWidth), ctnHeight),
        1000000,
        8
      )
    },
    rules() {
      return {
        goodsProperties: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsProperties') ||
              '请输入产品属性',
            trigger: 'change',
          },
        ],
        unitLength: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitLength') ||
              '请输入单品包装长',
            trigger: 'blur',
          },
        ],
        unitWidth: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitWidth') || '请输入单品包装宽',
            trigger: 'blur',
          },
        ],
        unitHeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitHeight') ||
              '请输入单品包装高',
            trigger: 'blur',
          },
        ],
        goodsWeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsWeight') || '请输入单品重量',
            trigger: 'blur',
          },
        ],
        unitWeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_unitWeight') ||
              '请输入单品包装重量',
            trigger: 'blur',
          },
        ],
        inCtnQty: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_inCtnQty') || '请输入装箱入数',
            trigger: 'blur',
          },
        ],
        ctnLength: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ctnLength') || '请输入纸箱长',
            trigger: 'blur',
          },
        ],
        ctnWidth: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ctnWidth') || '请输入纸箱宽',
            trigger: 'blur',
          },
        ],
        ctnHeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ctnHeight') || '请输入纸箱高',
            trigger: 'blur',
          },
        ],
        ctnNetWeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ctnNetWeight') || '请输入箱净重',
            trigger: 'blur',
          },
        ],
        ctnGrossWeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ctnGrossWeight') ||
              '请输入箱毛重',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const params = {
        ...this.formData,
        unitCbm: this.unitCbm,
        ctnCbm: this.ctnCbm,
        ctnNetWeight: this.ctnNetWeightKgRead,
        ctnGrossWeight: this.ctnGrossWeightKgRead,
      }
      this.$emit('saveSpecSize', params)
    },
    changeCtnGrossWeight() {
      this.ctnNetWeightKgRead = multiplyRound(
        this.formData.unitWeight,
        this.formData.inCtnQty,
        3
      )
      this.ctnGrossWeightKgRead = add(this.ctnNetWeightKgRead, 1)
    },
  },
}
</script>
